import { atom } from 'nanostores';

export const isSideBarOpen = atom(false);
export const isMobile = atom(false);
